function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoodsAndServices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.587,3.757C1.587,2.458 2.636,1.408 3.936,1.408L9.287,1.408C11.305,1.408 13.104,2.7 13.743,4.624L20.503,24.898C22.713,24.935 24.673,25.992 25.935,27.614L40.77,22.667C42.004,22.256 43.332,22.924 43.743,24.149C44.154,25.375 43.486,26.711 42.261,27.122L27.425,32.07C27.359,35.902 24.232,38.992 20.378,38.992C16.488,38.992 13.331,35.836 13.331,31.945C13.331,29.684 14.396,27.673 16.047,26.381L9.287,6.106L3.936,6.106C2.636,6.106 1.587,5.057 1.587,3.757ZM19.556,11.281C19.153,10.048 19.828,8.72 21.061,8.323L24.416,7.237L25.869,11.707L30.34,10.254L28.879,5.783L32.233,4.697C33.467,4.293 34.795,4.969 35.192,6.202L38.818,17.374C39.222,18.607 38.546,19.936 37.313,20.332L26.141,23.959C24.907,24.362 23.579,23.687 23.182,22.454L19.556,11.281Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoodsAndServices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/goods-and-services.458d0c2e0c58d26cd6ad4adab13b0c62.svg";